/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BadgeTextbox } from 'shared/libs/providers/badge-editor/elements/textbox';
import { ZD621_BADGE_PRINTING_PRESETS } from 'libs/utils/constants';
import { DEFAULT_FONT } from 'shared/libs/providers/badge-editor/enum';

import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import TextAlignmentControls from './panels/TextAlignmentControls.vue';
import ArrangementControls from './panels/ArrangementControls.vue';
import PositionControls from './panels/PositionControls.vue';
import DimensionControls from './panels/DimensionControls.vue';
import FontSizeControls from './panels/FontSizeControls.vue';
import RemoveActiveObject from './panels/RemoveActiveObject.vue';
import RotationControls from './panels/RotationControls.vue';
import ToolControls from './panels/ToolControls.vue';
import panelActions from './mixins/panel-actions';

/**
 * @emits input the textbox object
 * @emits uploaded the uploaded asset
 * @emits close-panel void
 * @emits remove-object void
 */
const __vue_script__ = {
    name: 'TextboxPanel',

    components: {
        BaseInput,
        BaseSelect,
        RadioButtons,
        ColorPicker,
        PositionControls,
        DimensionControls,
        FontSizeControls,
        RemoveActiveObject,
        TextAlignmentControls,
        ArrangementControls,
        ExpandableContent,
        RotationControls,
        ToolControls,
    },

    mixins: [panelActions],

    props: {
        event: {
            type: Object,
            required: true,
        },

        value: {
            type: BadgeTextbox,
            required: true
        },

        pageDimensions: {
            type: Object,
            required: true
        },

        fontFaces: {
            type: Array,
            required: true
        },

        preset: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            filterMimeRegex: /font\/*/,
            presetIsForZD621: false,
            colorPickerTooltip: undefined,
            selectedFont: undefined,
        };
    },

    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit('input', value);
            }
        }
    },

    watch: {
        preset: {
            immediate: true,
            // this should not be needed, preset is a string but without it switching text resets anything done here
            deep: true,
            handler(value) {
                this.presetIsForZD621 = ZD621_BADGE_PRINTING_PRESETS.includes(value);
                if (this.presetIsForZD621) {
                    // ZD621 only prints in black
                    this.fontColor = '#000000';
                }
                this.colorPickerTooltip = this.presetIsForZD621
                    ? this.$t('badge_editor.zd621_color_tooltip')
                    : undefined;
            }
        },
        selectedFont: {
            deep: true,
            handler(value) {
                if (value?._id) { this.innerValue.fontFamily = value._id; }
            }
        },
        value: {
            deep: true,
            handler(value) {
                let selected = this.fontFaces.find(({ _id }) => _id === value.fontFamily);
                if (!selected) selected = this.fontFaces.find(({ _id }) => _id === DEFAULT_FONT);
                this.selectedFont = selected;
            }
        }
    },

    methods: {
        /**
         * @param {object} change
         * @param {'width'|'height'|'fontSize'|'minFontSize'|'top'|'left'} change.property
         * @param {number} change.value
         */
        onChange({ property, value }) {
            this.innerValue[property] = value;
        },

        /** @param {'left'|'center'|'right'} textAlign */
        onTextAlignClick(textAlign) {
            this.innerValue.textAlign = textAlign;
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-panel"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"icon ic-align-left"}),_c('h4',[_vm._v(_vm._s(_vm.$t('badge_editor.text_panel')))])]),_c('div',{staticClass:"controls"},[_c('button',{staticClass:"btn btn-icon single btn-primary-alt close",on:{"click":function($event){return _vm.$emit('close-panel')}}},[_c('i',{staticClass:"icon ic-x"})])])]),_c('div',{staticClass:"note"},[_vm._v(_vm._s(_vm.$t('badge_editor.add_text_note')))]),_c('div',{staticClass:"section text-input"},[_c('base-input',{attrs:{"type":"text","name":"textValue","label":_vm.$t('badge_editor.add_text')},model:{value:(_vm.innerValue.text),callback:function ($$v) {_vm.$set(_vm.innerValue, "text", $$v)},expression:"innerValue.text"}})],1),_c('div',{staticClass:"note"},[_vm._v(_vm._s(_vm.$t('badge_editor.upload_font_note')))]),_c('div',{staticClass:"section"},[_c('template',{slot:"header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('badge_editor.select_font')))])]),_c('base-select',{attrs:{"name":"fontFamily","options":_vm.fontFaces,"label":_vm.$t('badge_editor.select_font')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.title))])]}}]),model:{value:(_vm.selectedFont),callback:function ($$v) {_vm.selectedFont=$$v},expression:"selectedFont"}}),_c('color-picker',{attrs:{"name":"fill","label":_vm.$t('badge_editor.font_color'),"disabled":_vm.presetIsForZD621,"hint":_vm.colorPickerTooltip},model:{value:(_vm.innerValue.fill),callback:function ($$v) {_vm.$set(_vm.innerValue, "fill", $$v)},expression:"innerValue.fill"}}),_c('font-size-controls',{attrs:{"font-size":_vm.innerValue.fontSize,"min-font-size":_vm.innerValue.minFontSize},on:{"change":_vm.onChange}})],2),_c('div',{staticClass:"section parameters"},[_c('text-alignment-controls',{attrs:{"text-align":_vm.innerValue.textAlign},on:{"click":_vm.onTextAlignClick}}),_c('dimension-controls',{attrs:{"width":_vm.innerValue.width,"height":_vm.innerValue.height,"page-dimensions":_vm.pageDimensions},on:{"change":_vm.onChange}}),_c('position-controls',{attrs:{"top":_vm.innerValue.top,"left":_vm.innerValue.left,"page-dimensions":_vm.pageDimensions},on:{"change":_vm.onChange}}),_c('arrangement-controls',{attrs:{"page-dimensions":_vm.pageDimensions},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}),(false)?_c('tool-controls',{attrs:{"value":_vm.innerValue},on:{"change":_vm.onChange,"duplicate":_vm.onDuplicate}}):_vm._e(),(false)?_c('rotation-controls',{attrs:{"angle":_vm.innerValue.angle},on:{"change":_vm.onChange}}):_vm._e()],1),_c('div',{staticClass:"section actions"},[_c('remove-active-object',{on:{"click":_vm.onRemove}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TextboxPanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__